// Import necessary functions from other files
import { showSearchBoxesOverlay, hideSearchBoxesOverlay } from './search_boxes_overlay';

let dandelionFinished = false;
let expandableBoxClickable = false;

// Function to toggle expandable box visibility
export function toggleExpandableBox() {
    console.log("toggleExpandableBox");

    const expandableBox = document.querySelector('.expandable-box');
    const expandableContent = document.querySelector('.expandable-detail');

    // Log the selected elements
    // console.log("expandableBox:", expandableBox);
    // console.log("expandableContent:", expandableContent);

    // Check if elements exist
    if (!expandableBox || !expandableContent) {
        console.error("Expandable box or content not found in the DOM.");
        return;
    }

    if (expandableBox.classList.contains('expandable-box-locked')) {
        expandableBox.classList.remove('expandable-box-locked');
        expandableContent.style.maxHeight = null;
        hideSearchBoxesOverlay(); // Hide the overlay when the expandable box is open
    } else {
        expandableBox.classList.add('expandable-box-locked');
        expandableContent.style.maxHeight = expandableContent.scrollHeight + 'px';
        showSearchBoxesOverlay(); // Show the overlay when the expandable box is closed
    }
}

// Ensure the function runs after DOM content is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    // Your code to bind the function to an event or call it directly
});


// Function to reattach event listener to expandable box after Turbo navigation
export function reattachExpandableBoxListener() {
    const expandableBox = document.querySelector('.expandable-box');
    if (expandableBox) {
        expandableBox.addEventListener('click', function() {
            if (expandableBoxClickable) {
                toggleExpandableBox();
            }
        });
    } else {
        console.log("IGNORED reattachExpandableBoxListener.");
    }
}


let turboLoadHandled = false;

// Event listener for Turbo load to ensure expandable box can be clicked after page reload
document.addEventListener('turbo:load', function() {
    reattachExpandableBoxListener();
    if (!turboLoadHandled) {
        hideSearchBoxesOverlay(); // Ensure the overlay is hidden after the page is fully loaded
        turboLoadHandled = true;
    }
});

// Event listener for dandelion animation finish
document.addEventListener('dandelion:finished', function() {
    dandelionFinished = true;
    if (turboLoadHandled) {
        hideSearchBoxesOverlay();
    }
});
